import React from 'react';
import './HexModal.css';

function HexModal({ open, onClose }) {
  if (!open) return null;

  return (
    <div className="modal-overlay">
      <div className="hex-modal-content">
        <button className="modal-close" onClick={onClose} aria-label="Close">
          <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M0 0h24v24H0z" fill="none"/>
            <path d="M18.3 5.71a1 1 0 0 0-1.41 0L12 10.59 7.11 5.7a1 1 0 1 0-1.41 1.41L10.59 12l-4.89 4.89a1 1 0 1 0 1.41 1.41L12 13.41l4.89 4.89a1 1 0 0 0 1.41-1.41L13.41 12l4.89-4.89a1 1 0 0 0 0-1.4z"/>
          </svg>
        </button>
        <h2>Understanding Hexadecimal</h2>

        <p>
          Computers store data using <strong>binary digits</strong> or <strong>bits</strong>.  That is, 0s and 1s.  
          <strong>  Hexadecimal</strong> (base-16) is a compact way of writing binary values.
          Each hex digit represents exactly <strong>four bits</strong>,
          making it easier to read and work with large binary numbers.
        </p>

        <table className="hex-table">
          <thead>
            <tr>
              <th>Decimal</th>
              <th>Binary</th>
              <th>Hexadecimal</th>
            </tr>
          </thead>
          <tbody>
            <tr><td>0</td><td>0000</td><td>0</td></tr>
            <tr><td>1</td><td>0001</td><td>1</td></tr>
            <tr><td>2</td><td>0010</td><td>2</td></tr>
            <tr><td>3</td><td>0011</td><td>3</td></tr>
            <tr><td>4</td><td>0100</td><td>4</td></tr>
            <tr><td>5</td><td>0101</td><td>5</td></tr>
            <tr><td>6</td><td>0110</td><td>6</td></tr>
            <tr><td>7</td><td>0111</td><td>7</td></tr>
            <tr><td>8</td><td>1000</td><td>8</td></tr>
            <tr><td>9</td><td>1001</td><td>9</td></tr>
            <tr><td>10</td><td>1010</td><td>A</td></tr>
            <tr><td>11</td><td>1011</td><td>B</td></tr>
            <tr><td>12</td><td>1100</td><td>C</td></tr>
            <tr><td>13</td><td>1101</td><td>D</td></tr>
            <tr><td>14</td><td>1110</td><td>E</td></tr>
            <tr><td>15</td><td>1111</td><td>F</td></tr>
            <tr><td>16</td><td>0001 0000</td><td>10</td></tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default HexModal;
